<script lang="ts" setup>
import type { StaticPagesListItem, StaticPagesListPaginationData } from '~/types/StaticPageList';

defineProps<{
  heading: string;
  items: StaticPagesListItem[];
  pagination: StaticPagesListPaginationData | undefined;
}>();

const route = useRoute();
</script>

<template>
  <div class="static-pages-list">
    <BreadcrumbsBlock />

    <h1>{{ heading }}</h1>

    <section
      v-if="items.length"
      class="flex flex-col"
    >
      <section class="static-pages-list__grid">
        <AppLink
          v-for="item in items"
          :key="item.id"
          :to="`${route.path}/${item.slug}`"
        >
          <StaticPageListItem :item="item" />
        </AppLink>
      </section>

      <PaginationBlock
        v-if="pagination"
        :pagination="{ ...pagination, page: pagination.current_page }"
        class="mt-8"
      />
    </section>

    <div v-else>Ничего не найдено</div>
  </div>
</template>

<style lang="scss" scoped>
.static-pages-list {
  @include inner-content;

  gap: 16px;

  &__grid {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    gap: 24px;

    @include screen-sm {
      grid-template-columns: 1fr 1fr;
    }

    @include screen-lg {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
}
</style>
